import { useNavigate } from "react-router-dom";
import { useRef } from "react";
import MeaPage from "../../../components/MeaPage";
import SecretariatWorkspaceBar from "../components/SecretariatWorkspaceBar";
import TrainingsListComponent from "../components/TrainingsListComponent";
import { useAuthContext } from "../../../hooks/useAuthContext";

const SecretariatSlotChangeRequestsListPage = () => {
  const { currentMembership } = useAuthContext();
  const navigate = useNavigate();
  const listRef = useRef();

  return (
    <MeaPage
      title="De quelle formation ?"
      breadcrumb={<SecretariatWorkspaceBar section="slot-change-requests" />}
        showBackButton={true}
        onBackButtonClick={() => navigate(`/school/${currentMembership?.school?.id}/secretariat`)}
    >
      <TrainingsListComponent
        ref={listRef}
        showAddButton={false}
        redirectPath="slot-change-requests"
      />
    </MeaPage>
  );
};

export default SecretariatSlotChangeRequestsListPage;
